// ============================================================
// BrandLogo — logo de la tienda desde la configuración de marca
//   variant="text"  → "URBAN" + <span>WEAR</span> (la clase del padre colorea el span)
//   variant="image" → imagen del logo (si no hay imagen, cae a texto)
//   variant="auto"  → imagen solo si branding.useImageInHeader está activo
// ============================================================
import type { CSSProperties } from 'react'
import { useBranding } from '@/hooks/useSiteConfig'

interface Props {
  variant?: 'text' | 'image' | 'auto'
  imgStyle?: CSSProperties
}

export default function BrandLogo({ variant = 'text', imgStyle }: Props) {
  const b = useBranding()
  const wantsImage = variant === 'image' || (variant === 'auto' && b.useImageInHeader)

  if (wantsImage && b.logoImage) {
    return (
      <img src={b.logoImage} alt={b.name}
        style={{ height: 40, width: 'auto', objectFit: 'contain', ...imgStyle }} />
    )
  }

  const [first, second] = b.logoText
  return <>{first}{second && <span>{second}</span>}</>
}
